module.exports = __webpack_public_path__ + "img/thebeautyspot.bc5401b4.jpg";